import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import AccidentIncidentReport from './model';
import type * as Types from './types';

export const fetchAllForChild = (childId: string) => {
    return RESTClient.getAuthenticatedObservable('v2/accident-reports', {childId}).map(results =>
        List(results.reports).map(AccidentIncidentReport.fromAPI),
    );
};

export const fetchWithIds = (reportIds: string[]) => {
    return RESTClient.getAuthenticatedObservable('v2/accident-reports', {reportIds}).map(results =>
        List(results.reports).map(AccidentIncidentReport.fromAPI),
    );
};

export const createAccidentIncidentReport = (report: Types.ReportForApiCreate) => {
    return RESTClient.postAuthenticatedObservable('v2/accident-reports', {report}).map(result =>
        AccidentIncidentReport.fromAPI(result.report),
    );
};

export const updateAccidentIncidentReport = (report: Types.ReportForApiUpdate) => {
    return RESTClient.putAuthenticatedObservable(`v2/accident-reports/${report.reportId}`, {report}).map(result =>
        AccidentIncidentReport.fromAPI(result.report),
    );
};

export const acknowledge = (reportId: string) => {
    return RESTClient.postAuthenticatedObservable(`v2/accident-reports/${reportId}/acknowledge`);
};

export const deleteReport = (reportId: string) => {
    return RESTClient.deleteAuthenticatedObservable(`v2/accident-reports/${reportId}`);
};
